import React, { useContext, useEffect } from 'react';

import { CaptionText, DropdownMenu } from '@paypalcorp/pp-react';
import PropTypes from 'prop-types';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import styles from '../Configurator.module.less';
import { trackFieldClosed, trackFieldFocus } from '../../../lib/fpti';

const FTPI_3DS_CONFIGURATION = '3DS Configuration';
const options = [
  {
    value: 'SCA_ALWAYS',
    label: 'SCA_ALWAYS'
  },
  {
    value: 'SCA_WHEN_REQUIRED',
    label: 'SCA_WHEN_REQUIRED'
  }
];

const defaultValue = options[0].value;

const ThreeDsConfigurator = ({ codeBlockKey }) => {
  const {
    code,
    OrderConfigurator: { update3dsSetting, threeDsSetting }
  } = useContext(IntegrationPageSectionContext);

  const isSectionActive = code.status[codeBlockKey];

  const handleChange = (e) => {
    update3dsSetting(e.target.value);
  };

  useEffect(() => {
    if (isSectionActive && !threeDsSetting) {
      // Setting the default value for 3DS on the first active render of the component
      update3dsSetting(defaultValue);
    }
  }, [code.status[codeBlockKey]]);

  if (!isSectionActive) return <></>;

  return (
    <div className={styles.configuration}>
      <div className={styles.configuration_item}>
        <CaptionText className={styles.configuration_text}>3DS Configuration</CaptionText>
        <DropdownMenu
          label="3DS Configuration"
          className={styles.configuration_dropdown}
          options={options}
          value={threeDsSetting}
          onClick={() => trackFieldFocus(FTPI_3DS_CONFIGURATION)}
          onChange={handleChange}
          onClose={() => trackFieldClosed(FTPI_3DS_CONFIGURATION)}
        />
      </div>
    </div>
  );
};

ThreeDsConfigurator.propTypes = {
  codeBlockKey: PropTypes.string.isRequired
};

export default ThreeDsConfigurator;
